<script>
import {Bar} from 'vue-chartjs'
import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'BarChart',
  components: {Bar},
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartData: {},
      chartOptions: {
        responsive: true,
        indexAxis: 'x',
        scales: {
          x: {
            ticks: {
              color: "black"
            },
            stacked: true,
          },
          y: {
            ticks: {
              color: "black"
            },
            stacked: true,
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (item) =>
                  `${item.dataset.label}: ${item.formattedValue} ${item.dataset.unit}`,
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              color: 'black',
            }
          }
        },
      }
    }
  },
  methods: {
    setData(data) {
      this.chartData = data
    },
  }
}
</script>

<template>
  <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
      :ref="chartId"
  />
</template>